import type { SupportedCountry } from '../types';
import { SupportedCountries } from '../types';
import { countriesList } from './countries-list';

const parseCountry = {
    /** Derives the country code from a hostname by matching against known domains. */
    host: (host: string): SupportedCountry | undefined => {
        return SupportedCountries.find((code) =>
            host.endsWith(countriesList[code].domain),
        );
    },
};

export { parseCountry };
